import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import GameTile from '../../gameTile/containers/GameTile';

function ListOfGamesComponent({
  gamesData,
  name,
  pageContext,
  pageType,
  sortPosition,
  isInitializedLoading,
  friendsData,
  gameDetailPlaceId,
  ...props
}) {
  const gameTileRef = useRef();

  const [listOfGames, setListOfGames] = useState(gamesData);

  useEffect(() => {
    if (gamesData?.length) {
      setListOfGames(gamesData);
    }
    return () => {};
  }, [gamesData]);

  return (
    <ul className='hlist game-cards'>
      {listOfGames.length > 0 &&
        listOfGames.map((game, index) => {
          const keyValue = `${game.universeId}${index}`;
          return (
            <li
              className='list-item game-card game-tile'
              id={game.universeId}
              key={keyValue}
              title={game?.name}>
              {game?.universeId && (
                <GameTile
                  game={game}
                  pageType={pageType}
                  ref={gameTileRef}
                  index={index}
                  sortName={name}
                  pageContext={pageContext}
                  sortPosition={sortPosition}
                  friendsData={friendsData}
                  gameDetailPlaceId={gameDetailPlaceId}
                  {...props}
                />
              )}
            </li>
          );
        })}
    </ul>
  );
}

ListOfGamesComponent.defaultProps = {
  friendsData: [],
  pageType: '',
  gameDetailPlaceId: null
};

ListOfGamesComponent.propTypes = {
  gamesData: PropTypes.arrayOf(PropTypes.shape({ universeId: PropTypes.number })).isRequired,
  name: PropTypes.string.isRequired,
  pageContext: PropTypes.shape({ pageId: PropTypes.string }).isRequired,
  sortPosition: PropTypes.number.isRequired,
  isInitializedLoading: PropTypes.bool.isRequired,
  translate: PropTypes.func.isRequired,
  friendsData: PropTypes.arrayOf(
    PropTypes.shape({
      presense: PropTypes.shape({ userPresenceType: PropTypes.number }),
      id: PropTypes.number,
      nameForDisplay: PropTypes.string
    })
  ),
  pageType: PropTypes.string,
  gameDetailPlaceId: PropTypes.number
};

export default ListOfGamesComponent;
